<script>

export default {
  computed: {
    timeframe () {
      return this.$timeframe
    },
  },
  watch: {
    timeframe: function (newData, oldData) {
      // ADD CACHE FETCHING FOR PREVIOUS TIMEFRAME!
      if (newData !== oldData) {
        this.resetAnalyticsObjects()
        this.fetchStreamAnalyses()
      }
    },
  },
  methods: {
    setTimeframe (timeframe) {
      this.$timeframe = timeframe
    },
  },
}
</script>
